import { BookOpen, Brain, GitBranch, Heart, Home, LayoutGrid, MessageCircle, Sparkles, Swords, Users } from 'lucide-react';
import type { ElementType } from 'react';
import React from 'react';
import type { TabType } from '../../../../types/flzhub';

export const NAV_ITEMS: { key: TabType; label: string; icon: ElementType; color: string }[] = [
  { key: 'chat', label: 'Chat', icon: MessageCircle, color: '#6366f1' },
  { key: 'stories', label: 'Stories', icon: BookOpen, color: '#ec4899' },
  { key: 'tests', label: 'Leaderboard', icon: LayoutGrid, color: '#f59e0b' },
  { key: 'suggestions', label: 'Suggestions', icon: Sparkles, color: '#10b981' },
  { key: 'topics', label: 'Topics', icon: MessageCircle, color: '#3b82f6' },
  { key: 'emotions', label: 'Emotions', icon: Heart, color: '#ef4444' },
  { key: 'competition', label: 'Arena', icon: Swords, color: '#8b5cf6' },
  { key: 'habitat', label: 'Habitat', icon: Home, color: '#06b6d4' },
  { key: 'brain', label: 'Neural', icon: Brain, color: '#a855f7' },
  { key: 'family', label: 'Family Tree', icon: GitBranch, color: '#f97316' },
  { key: 'expert-rooms', label: 'Expert Rooms', icon: Users, color: '#14b8a6' },
  { key: 'training', label: 'Training', icon: Sparkles, color: '#84cc16' },
];

export const getAgentColor = (name: string | null | undefined) => {
  const safeName = name || 'Unknown'
  const colors = ['#667eea', '#764ba2', '#f093fb', '#4facfe', '#43e97b', '#fa709a', '#fee140', '#30cfd0']
  return colors[safeName.charCodeAt(0) % colors.length]
}

export const getAgentInitials = (name: string | null | undefined) => {
  const safeName = name || 'U'
  return safeName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
}

export const getRoleLabel = (id: number): string => {
  if (id === 1) return 'EQ Guard';
  if (id === 2) return 'Mentor';
  if (id >= 3 && id <= 20) return 'Expert';
  return 'Agent';
}

export const getRoleTitle = (id: number): string => {
  if (id === 1) return 'Mother · EQ Guard';
  if (id === 2) return 'Father · Mentor';
  if (id >= 3 && id <= 20) return 'Expert';
  return 'Baby Agent';
}

export const getRoleBadgeColor = (id: number): string => {
  if (id === 1) return '#ec4899'; // pink - mother
  if (id === 2) return '#6366f1'; // indigo - father
  if (id >= 3 && id <= 20) return '#10b981'; // green - expert
  return '#8b949e'; // gray - baby
}

export const Badge = ({ children, color }: { children: React.ReactNode, color?: string }) => (
  <span style={{ fontSize: 8, background: color || 'rgba(255,255,255,0.1)', color: '#fff', padding: '1px 5px', borderRadius: 4, fontWeight: 700, textTransform: 'uppercase' }}>
    {children}
  </span>
);

export const Card = ({ children, style }: { children: React.ReactNode, style?: React.CSSProperties }) => (
  <div style={{ background: 'var(--os-card)', border: '1px solid var(--os-card-border)', borderRadius: 12, padding: 12, ...style }}>
    {children}
  </div>
);

export const Label = ({ children }: { children: React.ReactNode }) => (
  <div style={{ fontSize: 10, color: 'var(--os-muted)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
    {children}
  </div>
);
